(function () {
  const button = document.getElementById('back-to-top');
  if (!button) return;

  const scrollOffset = parseInt(button.dataset.scrollOffset, 10) || 400;
  const nativeBar = document.querySelector('.sticky-add-to-cart__bar');
  const customBar = document.querySelector('.f4d-sticky-atc');

  function updateStickyOffset() {
    let offset = 0;
    if (nativeBar && nativeBar.getAttribute('data-stuck') === 'true') {
      offset = nativeBar.offsetHeight;
    } else if (customBar && customBar.classList.contains('is-visible')) {
      offset = customBar.offsetHeight;
    }
    document.documentElement.style.setProperty('--sticky-atc-offset', offset + 'px');
  }

  function updateVisibility() {
    button.classList.toggle('is-visible', window.scrollY > scrollOffset);
    updateStickyOffset();
  }

  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateStickyOffset);

  if (nativeBar) {
    new MutationObserver(updateStickyOffset).observe(nativeBar, { attributes: true, attributeFilter: ['data-stuck'] });
  }

  updateVisibility();

  button.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
